module.exports = __webpack_public_path__ + "825bfd1e41a51e438c29f916dab37a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/a/a05.jpg
// module id = 489
// module chunks = 0